import Link from 'next/link';

import { List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { SectionHeader } from '@/src/components/molecules';
import { Section, Parallax } from '@/src/components/organisms';
import ChipCategory from '@/src/views/blog/BlogIndex/components/ChipCategory';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    background: 'white',
    overflow: 'hidden',
  },
  sectionWrapper: {
    height: 400,
    backgroundColor: '#0880bacc',
  },
  textWhite: {
    color: 'white',
  },
  title: {
    fontWeight: 'bold',
  },
  section: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemAvatar: {
    marginRight: theme.spacing(2),
  },
  avatar: {
    height: 60,
    width: 60,
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 0 0 auto',
  },
}));

function Hero({ date, title, description, author, cover, categories = [], ...rest }) {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.root} {...rest}>
      <Parallax backgroundImage={cover}>
        <div className={classes.sectionWrapper}>
          <Section className={classes.section}>
            <>
              <SectionHeader
                title={title}
                subtitle={description}
                align="left"
                data-aos="fade-up"
                titleProps={{
                  className: clsx(classes.title, classes.textWhite),
                  variant: 'h3',
                }}
                subtitleProps={{ className: classes.textWhite }}
              />
              <List disablePadding>
                <ListItem disableGutters>
                  <ListItemAvatar className={classes.listItemAvatar}>
                    <Avatar
                      src={author?.avatar?.url}
                      alt={author.name}
                      className={classes.avatar}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`Publicado por ${author.name}`}
                    secondary={`em ${intl.formatDate(date)}`}
                    primaryTypographyProps={{
                      className: classes.textWhite,
                      variant: 'subtitle1',
                    }}
                    secondaryTypographyProps={{
                      className: classes.textWhite,
                      variant: 'subtitle1',
                    }}
                  />
                </ListItem>
                {categories.length > 0 && (
                  <ListItem>
                    <div className={classes.tags}>
                      {categories
                        .map(item => item.category)
                        .map(category => (
                          <Link
                            key={category?.id}
                            href={['/blog/category', category.uid].join('/')}
                            passHref>
                            <ChipCategory
                              label={category.data?.name}
                              sx={{ backgroundColor: category.data?.color }}
                            />
                          </Link>
                        ))}
                    </div>
                  </ListItem>
                )}
              </List>
            </>
          </Section>
        </div>
      </Parallax>
    </div>
  );
}

Hero.propTypes = {
  date: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  author: PropTypes.object,
  cover: PropTypes.string,
  categories: PropTypes.array,
};

export default Hero;
